
import "/home/vsts/work/1/s/src/layouts/rightContentRender/index.less?modules";
export default {"wrap": `wrap-G_ymYddT`}
